import { Queries } from "@/constants/queries";
import { useApolloClient } from "@apollo/client/react";
import { useCallback, useLayoutEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Page() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const apolloClient = useApolloClient();

  const refreshUserQuery = useCallback(async () => {
    try {
      // Refetch the user query to get updated integration status
      await apolloClient.refetchQueries({
        include: [Queries.USER_QUERY],
      });
    } catch (error) {
      console.error("Failed to refresh user data:", error);
    }
  }, [apolloClient]);

  const clearUrlParams = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("integration");
    url.searchParams.delete("status");
    url.searchParams.delete("message");
    navigate(url.pathname + url.search, { replace: true });
  }, [navigate]);

  // Check URL parameters on mount and when they change
  useLayoutEffect(() => {
    const integration = searchParams?.get("integration");
    const status = searchParams?.get("status");
    const message = searchParams?.get("message");

    if (integration && status) {
      console.log("integration", integration);
      console.log("status", status);
      console.log("message", message);

      // Set integration state
      window.opener.postMessage({ integration, status, message }, "*");

      // Clear URL parameters after processing
      clearUrlParams();

      // Refresh user query
      refreshUserQuery();

      if (status === "success" || status === "error") {
        // Close the popup
        // window.close();
      }
    }
  }, [searchParams, clearUrlParams, refreshUserQuery]);

  return null;
}
